// Intelligente Bildsuch-Funktion
const findImageInSubdirectories = (filename) => {
  const folders = ["geigen", "bratschen", "celli", "kontrabässe"];

  // Suche in allen Unterordnern nach dem Bild
  for (const folder of folders) {
    try {
      // Versuche das Bild im entsprechenden Unterordner zu finden
      return require(`./bilder/${folder}/${filename}`);
    } catch (error) {
      // Wenn das Bild nicht gefunden wird, versuche den nächsten Ordner
      continue;
    }
  }

  // Falls das Bild in keinem Unterordner gefunden wird, gib null zurück
  console.warn(`Bild ${filename} wurde in keinem Unterordner gefunden`);
  return null;
};

// Funktion zum Laden aller Bilder für ein Instrument
const loadInstrumentImages = (bilder) => {
  return bilder
    .map((filename) => {
      const imagePath = findImageInSubdirectories(filename);
      if (imagePath) {
        return imagePath;
      }
      // Fallback: Platzhalter-Bild oder null
      return null;
    })
    .filter((image) => image !== null);
};

// Instrumentendaten
const instrumentsData = [
  {
    id: 1,
    typ: "g",
    jahr: 1778,
    title_de: "Geige Stradivari 1778",
    title_en: "Violin Stradivari 1778",
    text_de: "Meisterhafte Kopie einer Stradivari aus dem Jahr 1778",
    text_en: "Masterful copy of a Stradivarius from 1778",
    detail_text_de:
      "Diese außergewöhnliche Kopie einer Stradivarius aus dem Jahr 1778 wurde mit größter Sorgfalt und unter Verwendung traditioneller Techniken gefertigt. Das Instrument zeichnet sich durch einen warmen, vollen Klang und eine außergewöhnliche Projektion aus. Die Decke besteht aus feinjähriger Fichte aus dem Alpenraum, der Boden und die Zargen aus flammigem Ahorn. Der Lack wurde in traditioneller Schellack-Technik aufgetragen und verleiht dem Instrument seine charakteristische Ausstrahlung.",
    detail_text_en:
      "This exceptional copy of a Stradivarius from 1778 was crafted with the utmost care using traditional techniques. The instrument is characterized by a warm, full sound and exceptional projection. The top is made from fine-grained spruce from the Alpine region, the back and ribs from flamed maple. The varnish was applied using traditional shellac technique, giving the instrument its characteristic radiance.",
    bilder: [
      "violin_stradivari_1778_1.png",
      "violin_stradivari_1778_2.png",
      "violin_stradivari_1778_3.png",
      "violin_stradivari_1778_4.png",
    ],
  },
  {
    id: 2,
    typ: "b",
    jahr: 1740,
    title_de: "Bratsche Guarneri 1740",
    title_en: "Viola Guarneri 1740",
    text_de: "Handgefertigte Bratsche nach Guarneri del Gesù",
    text_en: "Handcrafted viola after Guarneri del Gesù",
    detail_text_de:
      "Diese Kopie nach Guarneri del Gesù aus dem Jahr 1740 besticht durch ihren kraftvollen und ausdrucksstarken Klang. Das charakteristische Design von Guarneri del Gesù mit seinen markanten f-Löchern und der besonderen Wölbung wurde detailgetreu nachgebildet. Das Instrument eignet sich besonders für Solisten, die einen warmen, aber durchsetzungsfähigen Ton suchen.",
    detail_text_en:
      "This copy after Guarneri del Gesù from 1740 captivates with its powerful and expressive sound. The characteristic design of Guarneri del Gesù with its distinctive f-holes and special arching has been faithfully reproduced. The instrument is particularly suitable for soloists seeking a warm yet assertive tone.",
    bilder: [
      "viola_guarneri_1740_1.png",
      "viola_guarneri_1740_2.png",
      "viola_guarneri_1740_3.png",
      "viola_guarneri_1740_4.png",
    ],
  },
  {
    id: 3,
    typ: "c",
    jahr: 1665,
    title_de: "Cello Amati 1665",
    title_en: "Cello Amati 1665",
    text_de: "Elegantes Cello nach Nicolò Amati",
    text_en: "Elegant cello after Nicolò Amati",
    detail_text_de:
      "Dieses elegante Cello nach Nicolò Amati aus dem Jahr 1665 verkörpert die feine Tradition der Amati-Familie. Das Instrument zeichnet sich durch seinen silbrigen, klaren Ton und die außergewöhnliche Ausgewogenheit aus. Die charakteristische gelbe Färbung des Amati-Lacks wurde originalgetreu nachempfunden.",
    detail_text_en:
      "This elegant cello after Nicolò Amati from 1665 embodies the fine tradition of the Amati family. The instrument is characterized by its silvery, clear tone and exceptional balance. The characteristic yellow coloring of Amati varnish has been faithfully reproduced.",
    bilder: [
      "cello_amati_1665_1.png",
      "cello_amati_1665_2.png",
      "cello_amati_1665_3.png",
      "cello_amati_1665_4.png",
    ],
  },
  {
    id: 4,
    typ: "k",
    jahr: 2024,
    title_de: "Kontrabass Modern 2024",
    title_en: "Modern Double Bass 2024",
    text_de: "Zeitgenössischer Kontrabass",
    text_en: "Contemporary double bass",
    detail_text_de:
      "Dieser moderne Kontrabass vereint traditionelle Handwerkskunst mit zeitgenössischen Erkenntnissen im Instrumentenbau. Das Instrument wurde speziell für die Anforderungen heutiger Musiker entwickelt und bietet eine ausgezeichnete Spielbarkeit sowie einen modernen, klaren Klang. Perfekt geeignet für Orchester- und Kammermusik.",
    detail_text_en:
      "This modern double bass combines traditional craftsmanship with contemporary insights in instrument making. The instrument was specifically developed for the requirements of today's musicians and offers excellent playability as well as a modern, clear sound. Perfect for orchestral and chamber music.",
    bilder: [
      "bass_modern_2024_1.png",
      "bass_modern_2024_2.png",
      "bass_modern_2024_3.png",
    ],
  },
  {
    id: 5,
    typ: "g",
    jahr: 2023,
    title_de: "Moderne Geige 2023",
    title_en: "Modern Violin 2023",
    text_de: "Zeitgenössische Handwerkskunst",
    text_en: "Contemporary craftsmanship",
    detail_text_de:
      "Diese moderne Geige vereint traditionelle Handwerkskunst mit zeitgenössischen Erkenntnissen im Geigenbau. Das Instrument wurde speziell für die Anforderungen heutiger Musiker entwickelt und bietet eine ausgezeichnete Spielbarkeit sowie einen modernen, klaren Klang. Perfekt geeignet für Orchester- und Kammermusik.",
    detail_text_en:
      "This modern violin combines traditional craftsmanship with contemporary insights in violin making. The instrument was specifically developed for the requirements of today's musicians and offers excellent playability as well as a modern, clear sound. Perfect for orchestral and chamber music.",
    bilder: [
      "violin_modern_2023_1.png",
      "violin_modern_2023_2.png",
      "violin_modern_2023_3.png",
    ],
  },
  {
    id: 6,
    typ: "b",
    jahr: 1850,
    title_de: "Historische Bratsche 1850",
    title_en: "Historic Viola 1850",
    text_de: "Authentische Bratsche aus dem 19. Jahrhundert",
    text_en: "Authentic viola from the 19th century",
    detail_text_de:
      "Diese historische Bratsche aus dem Jahr 1850 repräsentiert die Tradition des deutschen Instrumentenbaus des 19. Jahrhunderts. Das Instrument besticht durch seinen warmen, samtigen Klang und die außergewöhnliche Resonanz. Die authentische Alterung verleiht dem Instrument seinen charakteristischen Charme.",
    detail_text_en:
      "This historic viola from 1850 represents the tradition of 19th-century German instrument making. The instrument captivates with its warm, velvety sound and exceptional resonance. The authentic aging gives the instrument its characteristic charm.",
    bilder: [
      "viola_historic_1850_1.png",
      "viola_historic_1850_2.png",
      "viola_historic_1850_3.png",
      "viola_historic_1850_4.png",
    ],
  },
  {
    id: 7,
    typ: "c",
    jahr: 1720,
    title_de: "Cello Stradivari 1720",
    title_en: "Cello Stradivari 1720",
    text_de: "Exquisite Kopie nach Antonio Stradivari",
    text_en: "Exquisite copy after Antonio Stradivari",
    detail_text_de:
      "Dieses exquisite Cello nach Antonio Stradivari aus dem Jahr 1720 verkörpert die Perfektion des Meisters. Das Instrument zeichnet sich durch seinen kraftvollen, durchdringenden Klang und die außergewöhnliche Projektion aus. Jedes Detail wurde sorgfältig nach den Originalplänen gefertigt.",
    detail_text_en:
      "This exquisite cello after Antonio Stradivari from 1720 embodies the perfection of the master. The instrument is characterized by its powerful, penetrating sound and exceptional projection. Every detail was carefully crafted according to the original plans.",
    bilder: [
      "cello_stradivari_1720_1.png",
      "cello_stradivari_1720_2.png",
      "cello_stradivari_1720_3.png",
    ],
  },
  {
    id: 8,
    typ: "k",
    jahr: 1880,
    title_de: "Französischer Kontrabass 1880",
    title_en: "French Double Bass 1880",
    text_de: "Historischer französischer Kontrabass",
    text_en: "Historic French double bass",
    detail_text_de:
      "Dieser historische französische Kontrabass aus dem Jahr 1880 repräsentiert die hohe Kunst des französischen Instrumentenbaus. Das Instrument besticht durch seinen warmen, runden Klang und die außergewöhnliche Spielbarkeit. Die charakteristische französische Bauweise verleiht dem Bass seinen unverwechselbaren Charakter.",
    detail_text_en:
      "This historic French double bass from 1880 represents the high art of French instrument making. The instrument captivates with its warm, round sound and exceptional playability. The characteristic French construction gives the bass its unmistakable character.",
    bilder: [
      "bass_french_1880_1.png",
      "bass_french_1880_2.png",
      "bass_french_1880_3.png",
      "bass_french_1880_4.png",
    ],
  },
];

// Erweitere die Daten mit geladenen Bildern
const instruments = instrumentsData.map((instrument) => ({
  ...instrument,
  loadedImages: loadInstrumentImages(instrument.bilder),
}));

export default instruments;
export { findImageInSubdirectories, loadInstrumentImages };
